export default __webpack_public_path__ + "static/media/statistics.93e6719d.svg";